import React from 'react'
import {
  EmptyState,
  EmptyStateFlex,
  EmptyStateIllustrationImage,
} from 'components/EmptyState'
import { useBrandingSettings } from 'hooks/branding'

interface BillingEmptyStateProps {
  title: string
  subtitle: string
  children?: React.ReactNode
}

export default function BillingEmptyState({
  title,
  subtitle,
  children,
}: BillingEmptyStateProps) {
  const { corporateMode } = useBrandingSettings()

  return (
    <EmptyStateFlex>
      <EmptyState
        hideIllustration={corporateMode}
        animate
        image={
          <EmptyStateIllustrationImage
            src={require('assets/images/img_no-billing-methods-v2.svg')}
            alt="Illustration of a man reading a large invoice"
          />
        }
        title={title}
        subtitle={subtitle}
      >
        {children}
      </EmptyState>
    </EmptyStateFlex>
  )
}
